
import styles from '../style.module.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import ClockIcon from 'assets/SVG/ClockIcon';
import PhoneSvg from "assets/SVG/PhoneSvg";
import "swiper/css";

function formatBranchPhone(raw) {
    if (!raw) return "";
    const digits = String(raw).replace(/\D/g, "");

    if (digits.startsWith("374") && digits.length >= 11) {
        const local = digits.slice(3);
        return `0${local.slice(0, 2)}-${local.slice(2, 4)}-${local.slice(4, 6)}-${local.slice(6, 8)}`;
    }

    if (digits.startsWith("0") && digits.length >= 9) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 7)}-${digits.slice(7, 9)}`;
    }

    return String(raw).trim();
}

function formatBranchWorkTime(raw) {
    if (!raw) return "";
    return String(raw)
        .replace(/\s+/g, "")
        .replace(/[–—]/g, "-");
}

function BranchesSlider(props) {

    const { addresses, selectedIndex, handleMarkerClick, handleAddressClick } = props;
    const { currentLanguage } = useSelector(({ main }) => main);
    if (!addresses || addresses.length === 0) return null;

    return (
        <div className={styles.branches_slider}>
            <Swiper
                spaceBetween={12}
                slidesPerView="auto"
                speed={300}
                allowTouchMove={true}
                mousewheel={false}
                nested={true}
                resistanceRatio={0.65}
            >
                {addresses.map((address, index) => {
                    const isActive = selectedIndex === index;
                    const workTime = formatBranchWorkTime(address['work_time_' + currentLanguage]);
                    const phone = formatBranchPhone(address['tel_' + currentLanguage]);
                    const telHref = phone ? `tel:${phone.replace(/\D/g, "")}` : undefined;

                    return (
                        <SwiperSlide
                            key={address.id.toString()}
                            className={styles.branch_slide}
                            onClick={() => {
                                handleMarkerClick(address, index);
                            }}
                        >
                            <div
                                className={`${styles.branch_card} ${isActive ? styles.branch_card_active : ""}`}
                            >
                                <div className={styles.branch_image_wrap}>
                                    <img
                                        src={process.env.REACT_APP_STORAGE_URL + address['image_' + currentLanguage]}
                                        alt={address.name || "branch"}
                                        className={styles.branch_image}
                                    />
                                    <div className={styles.address_working_times}>
                                        <div className={styles.branch_meta_item}>
                                            <ClockIcon/>
                                            <span>{workTime}</span>
                                        </div>
                                        <div className={styles.branch_meta_divider} />
                                        <a
                                            className={styles.branch_meta_item}
                                            href={telHref}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <PhoneSvg
                                                width={12}
                                                height={12}
                                            />
                                            <span>{phone}</span>
                                        </a>
                                    </div>
                                </div>
                                <span className={styles.branch_address}>
                                    { address['address_' + currentLanguage] }
                                </span>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}

export default BranchesSlider;
